import React, { useState } from "react";
import Footer from "./footer";
import { Link } from "react-router-dom";
import { Modal, Button } from "react-bootstrap";
import axios from "axios";
import Swal from "sweetalert2";

const Contact = () => {
  const [form, setForm] = useState({ name: "", email: "", message: "" });
  const [show, setShow] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleChange = (e) =>
    setForm({ ...form, [e.target.name]: e.target.value });

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      await axios.post("https://bimanager.nexteck.uk/api/contact", form);
      // setShow(true);
      setForm({ name: "", email: "", message: "" });
      Swal.fire("Contact Successfully!");
    } catch (err) {
      Swal.fire("Something went wrong");

    } finally {
      setLoading(false);
    }
  };
 const [isMobileNavOpen, setIsMobileNavOpen] = useState(false);
    
      const toggleNav = () => setIsMobileNavOpen(!isMobileNavOpen);
      const closeNav = () => setIsMobileNavOpen(false);
  return (
    <>
        <div style={{ backgroundColor: "#51477E" }} >


     <header  className="header container">
  <div  className="header-top">
    <div className="logoManager">
        <Link to='/' style={{ textDecoration: "none" }}>
      <h3 style={{ color: "#fff" }}>
        BI <span>Manager</span>
      </h3>
        </Link>
                              
        
    </div>

    {/* Mobile Toggle Button on the right */}
    <button className="nav-toggle d-md-none" onClick={toggleNav}>
      ☰
    </button>
  </div>

  {/* Navigation Menu */}
  <nav className={`nav ${isMobileNavOpen ? "open" : ""}`}>
    <button className="nav-close d-md-none" onClick={closeNav}>✕</button>
    <ul>
      <li><Link to="/" onClick={closeNav}>Home</Link></li>
      <li><Link to="/about" onClick={closeNav}>About</Link></li>
      <li><Link to="/" onClick={closeNav}>CreateRFQ</Link></li>
      <li><Link to="/" onClick={closeNav}>ForVendors</Link></li>
      <li><Link to="/faqs" onClick={closeNav}>FAQ's</Link></li>
      <li><Link to="/contact" onClick={closeNav}>Contact</Link></li>
      <li>
        <Link to="/login">
          <button className="login-btn">Login</button>
        </Link>
      </li>
    </ul>
  </nav>
</header>
    </div>

   <div className="container py-5">
        <h2 className="text-center mb-5" style={{ color: "#FF650F" }}>
          Contact Us
        </h2>

        <div className="row align-items-center">
          <div className="col-lg-6 mb-4 text-center">
            <img
              src="/contact.jpg"
              alt="Contact"
              className="img-fluid rounded"
            />
          </div>

          <div className="col-lg-6">
            <form onSubmit={handleSubmit} className="p-4 shadow rounded bg-white">
              <div className="mb-3">
                <label>Name</label>
                <input
                  className="form-control"
                  name="name"
                  value={form.name}
                  onChange={handleChange}
                  required
                />
              </div>

              <div className="mb-3">
                <label>Email</label>
                <input
                  type="email"
                  className="form-control"
                  name="email"
                  value={form.email}
                  onChange={handleChange}
                  required
                />
              </div>

              <div className="mb-3">
                <label>Message</label>
                <textarea
                  className="form-control"
                  rows="4"
                  name="message"
                  value={form.message}
                  onChange={handleChange}
                  required
                />
              </div>

              <button
                className="btn w-100 text-white"
                style={{ backgroundColor: "#FF650F" }}
                disabled={loading}
              >
                {loading ? "Sending..." : "Send Message"}
              </button>
            </form>
          </div>
        </div>
      </div>

    

        <Footer/>
    
    </>
  );
};

export default Contact;
